import { SendLimitDefinition, SERVICE_PROVIDERS } from 'modules/graphql/types';
import { ITERABLE_SMS, TELNYX, TWILIO } from './sendingPlatforms';

export const SERVICE_PROVIDER_NAMES = {
  [SERVICE_PROVIDERS.ITERABLE]: 'Iterable',
  [SERVICE_PROVIDERS.MAILGUN]: 'MailGun',
  [SERVICE_PROVIDERS.MAILGUN_EU]: 'MailGun EU',
  [SERVICE_PROVIDERS.DYN]: 'Dyn',
  [SERVICE_PROVIDERS.SENDGRID]: 'SendGrid',
  [SERVICE_PROVIDERS.SPARKPOST]: 'SparkPost',
  [SERVICE_PROVIDERS.SPARKPOST_EU]: 'SparkPostEU',
  [SERVICE_PROVIDERS.SPARKPOST_ELITE]: 'SparkPost Elite',
  [SERVICE_PROVIDERS.TELNYX]: 'Telnyx',
  [SERVICE_PROVIDERS.TWILIO]: 'Twilio',
  [SERVICE_PROVIDERS.CUSTOM_MTA]: 'Custom email platform',
  [SERVICE_PROVIDERS.COINBASE_MTA]: '',
  [SERVICE_PROVIDERS.SFMC]: '',
  [SERVICE_PROVIDERS.NO_OP]: '',
  [SERVICE_PROVIDERS.INFOBIP]: 'InfoBip',
};

export const DEFAULT_SENDER_TEXT = 'Default account';
export const SET_DEFAULT_SENDER_TEXT = 'Use as default account';
export const RESET_DEFAULT_SENDER_TEXT = 'Remove as default account';

export const SENDING_PLATFORMS_PAGE_TEXT = {
  PAGE_HEADER: 'Sending Platforms',
  CONNECTED_HEADER: 'Manage connected platforms',
  UNCONNECTED_HEADER: 'Connect a new platform',
  CONNECTED_EMPTY_STATE: 'Nothing yet! To get started, browse the integrations listed below.',
  UNCONNECTED_EMPTY_STATE: 'You’re using all the sending platforms we support. Nice work!',
};

export const SES_ACCOUNT_NAME = 'Iterable Shared Pool';

export const SMS_SENDER_TERMS_BY_SENDING_PLATFORM: Record<
  typeof TELNYX | typeof TWILIO | typeof ITERABLE_SMS,
  string
> = {
  [TELNYX]: 'message profile',
  [TWILIO]: 'messaging service',
  [ITERABLE_SMS]: 'messaging service',
};

export const SMS_SENDER_TERMS_BY_SERVICE_PROVIDER: Record<
  SERVICE_PROVIDERS.TELNYX | SERVICE_PROVIDERS.TWILIO,
  string
> = {
  [SERVICE_PROVIDERS.TELNYX]: 'message profile',
  [SERVICE_PROVIDERS.TWILIO]: 'messaging service',
};

export const SMS_VERIFICATION_PROFILE_TERM = 'verification profile';

export const PHONE_NUMBER_LABEL_BY_SENDING_PLATFORM = {
  [TELNYX]: 'Messaging profile ID',
  [TWILIO]: 'Messaging service ID',
  [ITERABLE_SMS]: 'Messaging service ID',
};

export const WHATSAPP_SEND_LIMIT_DISPLAY_MAPPING: Record<
  SendLimitDefinition,
  { tier: string; friendlyNumber?: string } | null
> = {
  Limit50: { tier: 'Tier 0', friendlyNumber: '50' },
  Limit250: { tier: 'Tier 0', friendlyNumber: '250' },
  Limit1K: { tier: 'Tier 1', friendlyNumber: '1,000' },
  Limit10K: { tier: 'Tier 2', friendlyNumber: '10,000' },
  Limit100K: { tier: 'Tier 3', friendlyNumber: '100,000' },
  Unlimited: { tier: 'Tier 4' },
  LimitNa: null,
};
